const API_VERSION = 'v2'

const CUSTOMER_BASE_PATH = `/cliente/${API_VERSION}`
const BACKOFFICE_BASE_PATH = `/backoffice/${API_VERSION}`
const ORDER_DRAFT_BASE_PATH = `/rascunho/${API_VERSION}`
const MANAGE_OV_BASE_PATH = `/gerir-ov`
const FAIR_SHARE_BASE_PATH = `/services/fair-share/quota-management/v1`
const EDI_PATH = `/edi/${API_VERSION}`

const BACKOFFICE_RANGES_PATH = `${BACKOFFICE_BASE_PATH}/politica_alcadas`
const ORDER_DRAFT_PATH = `${ORDER_DRAFT_BASE_PATH}`

// TODO: Refactor the others endpoints to use the new structure
export const endpoints = {
  backofficeClusters: `${BACKOFFICE_BASE_PATH}/clusters`,
  backofficeClustersDownloadExcel: `${BACKOFFICE_BASE_PATH}/clusters/excel`,
  backofficeClustersIssuesDownloadExcel: `${BACKOFFICE_BASE_PATH}/clusters/issues`, // NOTE: /backoffice/v2/clusters/issues/{processId}/excel
  // Backoffice
  backofficeClustersMaterials: `${BACKOFFICE_BASE_PATH}/clusters/materials`,
  backofficeClustersTracking: `${BACKOFFICE_BASE_PATH}/clusters/tracking`,
  backofficeClustersUpload: `${BACKOFFICE_BASE_PATH}/clusters/upload`,
  // Política de Alçadas
  backofficeRanges: {
    downloadExcel: `${BACKOFFICE_RANGES_PATH}/excel`,
    history: `${BACKOFFICE_RANGES_PATH}/listar_historico`,
    list: `${BACKOFFICE_RANGES_PATH}/listar_alcadas`,
    requestReview: `${BACKOFFICE_RANGES_PATH}/solicita_analise`,
    review: `${BACKOFFICE_RANGES_PATH}/revisao_alcada`,
    reviewAnalysis: `${BACKOFFICE_RANGES_PATH}/realizar_analise`,
    reviewVisualization: `${BACKOFFICE_RANGES_PATH}/visualizar_revisao`,
    update: `${BACKOFFICE_RANGES_PATH}/revisao_alcada`,
    version: `${BACKOFFICE_RANGES_PATH}/obter_ultima_revisao_alcada`,
  },
  // Customer
  /**
   * @deprecated This endpoint is deprecated and should not be used in new features
   * Use the new customer endpoint`
   */
  clients: `${CUSTOMER_BASE_PATH}/ListClienteEstruturaComl`,
  customers: `${CUSTOMER_BASE_PATH}/estruturacomercial/listar-clientes`,
  // Gestão de EDI
  ediManagement: {
    list: `${EDI_PATH}/solicitacoes`,
    logs: (codigo: string) => `${EDI_PATH}/solicitacoes/${codigo}/logs`,
    reprocess: (orderNumber: string) => `${EDI_PATH}/solicitacoes/${orderNumber}/reprocessar`,
    reprocessBatch: `${EDI_PATH}/solicitacoes/reprocessar`,
    status: `${EDI_PATH}/solicitacoes/status`,
  },
  // Fair Share
  fairShare: {
    downloadFairShareBMU: `${FAIR_SHARE_BASE_PATH}/DownloadFairShareBMU`,
    downloadFairShareOffice: `${FAIR_SHARE_BASE_PATH}/DownloadFairShareGNV`,
    editMaterialLevel: `${FAIR_SHARE_BASE_PATH}/AlterarNivelBloqueio`,
    getBMUFairShare: `${FAIR_SHARE_BASE_PATH}/ConsultarFairShareBMU`,
    getFairShareByMaterial: `${FAIR_SHARE_BASE_PATH}/ConsultarFairShareCorBMU`,
    getFairShareTracking: `${FAIR_SHARE_BASE_PATH}/tracking/listar`,
    getMaterialShare: `${FAIR_SHARE_BASE_PATH}/ConsultarDisponibilidadePorCentroMaterial`,
    getOfficeByMaterialFairShare: `${FAIR_SHARE_BASE_PATH}/ConsultarFairShareCorGNV`,
    getOfficeFairShare: `${FAIR_SHARE_BASE_PATH}/ConsultarFairShareGNV`,
    openOfficeWallets: `${FAIR_SHARE_BASE_PATH}/AberturaCarteira`,
    uploadShareBMU: `${FAIR_SHARE_BASE_PATH}/distribuicao/upload-bmu`,
    uploadShareMeta: `${FAIR_SHARE_BASE_PATH}/meta/upload`,
    uploadShareOffice: `${FAIR_SHARE_BASE_PATH}/distribuicao/upload-gnv`,
  },
  // Key Accounts
  keyAccounts: `${CUSTOMER_BASE_PATH}/clientes-especiais`,
  keyAccountsTracking: `${CUSTOMER_BASE_PATH}/clientes-especiais/trackings`,
  // Gerir OV
  manageOv: {
    getReasonsJustification: `${MANAGE_OV_BASE_PATH}/motivos-negociacao-diferenciada`,
    getReasonsPromotion: `${MANAGE_OV_BASE_PATH}/motivo-promocional`,
  },
  // ND - Negociação Diferenciada
  nd: {
    requestHistory: '/gerir-ov/negociacao-diferenciada/exportar-historico',
  },
  // Rascunho - Pedido
  orderDraft: {
    getIncoterm: `${ORDER_DRAFT_PATH}/listar-incoterm`,
    getNegotiationJustification: (orderNumber: string) =>
      `${ORDER_DRAFT_PATH}/${orderNumber}/obter-dados-justificativa-negociacao-diferenciada`,
    saveOrderND: `${ORDER_DRAFT_PATH}/justificativas`,
  },
  // Home
  /// Header
  //// Recommendations
  recommendationsDownloadExcel: `${MANAGE_OV_BASE_PATH}/databricks/exportar-recomendacao`,
  salesCalendar: {
    create: `${BACKOFFICE_BASE_PATH}/calendarios/novo`,
    delete: `${BACKOFFICE_BASE_PATH}/calendarios/excluir`,
    edit: `${BACKOFFICE_BASE_PATH}/calendarios/editar`,
    list: `${BACKOFFICE_BASE_PATH}/calendarios`,
    tracking: `${BACKOFFICE_BASE_PATH}/calendarios/trackings`,
  },
} as const
